import { createSelector } from 'reselect'
import {
  formatEntities,
} from 'utils/formatter'

const getInvestmentPlansState = state => state.investmentPlans

const getInvestmentPlans = createSelector(
  getInvestmentPlansState,
  state => state.investmentPlans,
)

export const getMostRecentInvestmentPlan = createSelector(
  getInvestmentPlans,
  (investmentPlans) => {
    const formattedPlans = formatEntities(investmentPlans)

    const latestDate = new Date(Math.max.apply(null, formattedPlans.map(e =>
      new Date(e.createdDate)
    )))

    return formattedPlans.find(plan =>
      new Date(plan.createdDate).toString() === latestDate.toString() && plan.isActive
    )
  }
)

export const getCurrentInvestmentPlan = createSelector(
  getMostRecentInvestmentPlan,
  (investmentPlan) => {
    if (investmentPlan) {
      return {
        id: investmentPlan.id,
        strategy: investmentPlan.strategy,
        goals: investmentPlan.goals,
      }
    }
  }
)

export default {
  getCurrentInvestmentPlan
}



// WEBPACK FOOTER //
// ./src/selectors/onlineExperience/investmentPlans.js